var cifMg = ["301 201", "<g fill='none'><path fill='#FFF' d='M.5.5h300v200H.5z'/><path fill='#FC3D32' d='M100.5.5h200v100h-200z'/><path fill='#007E3A' d='M100.5 100.5h200v100h-200z'/></g>"];

export { cifMg };
